import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import ProgressBar from './ProgressBar'

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 41;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.4);
`

// Use `role='status'` so screen readers announce the loading label
const LoadingOverlay = ({ label = 'Loading' }) => (
  <Backdrop role='status' aria-busy={true} aria-label={label}>
    <ProgressBar type='circular' mode='indeterminate' multicolor />
  </Backdrop>
)

LoadingOverlay.propTypes = {
  label: PropTypes.string,
}

export default LoadingOverlay
